import React, { useEffect, useMemo, useState } from "react";
import DeliveryFeedback from "../../components/shared/DeliveryFeedback/DeliveryFeedback";
import "./TrackingPage.css";

const TRACKING_NUMBER = "SC-2024-847291";

const T = {
    en: {
        lang_select: "Select Language",
        lang_available: "Available Languages",
        tracking_label: "Tracking",
        live_update: "Live Update",
        status_current: "Out for Delivery",
        step_ordered: "Ordered",
        step_warehouse: "Warehouse",
        step_picked: "Picked Up",
        step_enroute: "En Route",
        step_delivered: "Delivered",
        section_package: "Package Information",
        tracking_number: "Tracking Number",
        badge_active: "Active",
        track_sub: "Standard delivery · 1 package",
        copy: "Copy",
        copied: "Copied",
        your_courier: "Your Courier",
        eta_away: "8 min ETA",
        shipping_address: "Shipping Address",
        delivering_to: "Delivering To",
        apt_info: "Apt 7, Floor 3",
        recipient: "Recipient",
        est_delivery: "Estimated Delivery",
        on_time: "On Time",
        arrives_today: "Arrives Today",
        time_window: "± 10 min window",
        date_label: "Date",
        day_saturday: "Saturday",
        section_history: "Tracking History",
        status_updates: "Status Updates",
        tl_confirmed: "Order Confirmed",
        tl_confirmed_desc: "Package registered in Smart Cargo system",
        tl_warehouse: "Arrived at Warehouse",
        tl_warehouse_desc: "Package sorted and ready for dispatch · Binəqədi Hub",
        tl_assigned: "Assigned to Courier",
        tl_assigned_desc: "Anar Həsənov picked up your package",
        tl_enroute: "Out for Delivery 🏍️",
        tl_enroute_desc: "Courier is on the way — 2.4 km from your address",
        tl_delivered: "Delivered",
        tl_delivered_desc: "Estimated arrival: 14:35 today",
        today: "Today",
        now_live: "Now · Live",
        pending: "Pending",
        section_prefs: "Preferences",
        delivery_instructions: "Delivery Instructions",
        chip_door: "Leave at door",
        chip_ring: "Ring doorbell",
        chip_call: "Call on arrival",
        chip_neighbour: "Leave with neighbour",
        chip_nocontact: "No-contact delivery",
        instr_placeholder: "Add specific instructions for your courier…",
        save_instructions: "Save Instructions",
        reschedule: "Reschedule Delivery",
        optional: "Optional",
        current_date: "Today · Saturday, April 12",
        current_window: "14:00 – 16:00 window · Active",
        change: "Change",
        select_date: "Select a New Date",
        time_slots: "Select Delivery Window",
        confirm_schedule: "Confirm New Schedule",
        report_issue: "Report an Issue",
        report_title: "Report an Issue",
        report_subtitle:
            "Tell us what went wrong — your report goes directly to the Smart Cargo operations team.",
        issue_late: "Delivery Late",
        issue_wrong: "Wrong Package",
        issue_damaged: "Item Damaged",
        issue_courier: "Courier Behaviour",
        issue_missing: "Package Missing",
        issue_other: "Other",
        issue_desc_label: "Describe the issue",
        issue_placeholder: "Please describe what happened in detail…",
        issue_contact_label: "Your phone (for follow-up)",
        issue_submit: "Send Report to Admin",
        issue_success_title: "Report Sent!",
        issue_success_desc:
            "Your issue has been sent to the Smart Cargo team. We'll follow up shortly.",
        toast_copied: "Tracking number copied!",
        toast_instructions: "Instructions saved! Courier notified.",
        toast_noinstruction: "Please add an instruction first",
        toast_rescheduled: "Delivery rescheduled!",
        toast_issue_sent: "Report sent to admin team!",
    },
    az: {
        lang_select: "Dil seçin",
        lang_available: "Mövcud dillər",
        tracking_label: "İzləmə",
        live_update: "Canlı Yeniləmə",
        status_current: "Çatdırılma yolundadır",
        step_ordered: "Sifariş edildi",
        step_warehouse: "Anbar",
        step_picked: "Götürüldü",
        step_enroute: "Yolda",
        step_delivered: "Çatdırıldı",
        section_package: "Bağlama Məlumatı",
        tracking_number: "İzləmə Nömrəsi",
        badge_active: "Aktiv",
        track_sub: "Standart çatdırılma · 1 bağlama",
        copy: "Kopyala",
        copied: "Kopyalandı",
        your_courier: "Kuryer",
        eta_away: "8 dəq ETA",
        shipping_address: "Çatdırılma Ünvanı",
        delivering_to: "Çatdırılır",
        apt_info: "Mənzil 7, Mərtəbə 3",
        recipient: "Alan şəxs",
        est_delivery: "Təxmini Çatdırılma",
        on_time: "Vaxtında",
        arrives_today: "Bu gün gəlir",
        time_window: "± 10 dəq aralıq",
        date_label: "Tarix",
        day_saturday: "Şənbə",
        section_history: "İzləmə Tarixi",
        status_updates: "Status Yeniləmələri",
        tl_confirmed: "Sifariş Təsdiqləndi",
        tl_confirmed_desc: "Bağlama Smart Cargo sisteminə qeydiyyata alınıb",
        tl_warehouse: "Anbara Çatdı",
        tl_warehouse_desc:
            "Bağlama çeşidlənib, göndərilməyə hazırdır · Binəqədi Hub",
        tl_assigned: "Kuryerə Verildi",
        tl_assigned_desc: "Anar Həsənov bağlamanızı götürdü",
        tl_enroute: "Çatdırılma yolundadır 🏍️",
        tl_enroute_desc: "Kuryer yoldadır — ünvanınıza 2.4 km",
        tl_delivered: "Çatdırıldı",
        tl_delivered_desc: "Təxmini vaxt: bu gün 14:35",
        today: "Bu gün",
        now_live: "İndi · Canlı",
        pending: "Gözlənilir",
        section_prefs: "Seçimlər",
        delivery_instructions: "Çatdırılma Təlimatları",
        chip_door: "Qapıda buraxın",
        chip_ring: "Zəng çalın",
        chip_call: "Gəldikdə zəng edin",
        chip_neighbour: "Qonşuya verin",
        chip_nocontact: "Kontaktsız çatdırılma",
        instr_placeholder: "Kuryer üçün xüsusi təlimatlar əlavə edin…",
        save_instructions: "Saxla",
        reschedule: "Vaxtı Yenidən Planlaşdır",
        optional: "İstəyə bağlı",
        current_date: "Bu gün · Şənbə, 12 Aprel",
        current_window: "14:00 – 16:00 aralığı · Aktiv",
        change: "Dəyiş",
        select_date: "Yeni Tarix Seçin",
        time_slots: "Çatdırılma Aralığını Seçin",
        confirm_schedule: "Yeni Cədvəli Təsdiqlə",
        report_issue: "Problem Bildir",
        report_title: "Problem Bildir",
        report_subtitle:
            "Nə baş verdiyini bildirin — məlumatınız birbaşa Smart Cargo əməliyyat komandasına göndərilir.",
        issue_late: "Gecikmiş çatdırılma",
        issue_wrong: "Yanlış bağlama",
        issue_damaged: "Zədəli əşya",
        issue_courier: "Kuryer davranışı",
        issue_missing: "Bağlama yoxdur",
        issue_other: "Digər",
        issue_desc_label: "Problemi izah edin",
        issue_placeholder: "Nə baş verdiyini ətraflı izah edin…",
        issue_contact_label: "Telefon nömrəniz (cavab üçün)",
        issue_submit: "Admin-ə Göndər",
        issue_success_title: "Bildiriş Göndərildi!",
        issue_success_desc:
            "Probleminiz Smart Cargo komandasına göndərildi. Tezliklə sizinlə əlaqə saxlayacağıq.",
        toast_copied: "İzləmə nömrəsi kopyalandı!",
        toast_instructions: "Təlimatlar saxlandı!",
        toast_noinstruction: "Zəhmət olmasa təlimat əlavə edin",
        toast_rescheduled: "Çatdırılma planlaşdırıldı!",
        toast_issue_sent: "Bildiriş komandaya göndərildi!",
    },
    ru: {
        lang_select: "Выбрать язык",
        lang_available: "Доступные языки",
        tracking_label: "Отслеживание",
        live_update: "Обновление в реальном времени",
        status_current: "В пути к вам",
        step_ordered: "Заказано",
        step_warehouse: "Склад",
        step_picked: "Получено",
        step_enroute: "В пути",
        step_delivered: "Доставлено",
        section_package: "Информация о посылке",
        tracking_number: "Номер отслеживания",
        badge_active: "Активен",
        track_sub: "Стандартная доставка · 1 посылка",
        copy: "Копировать",
        copied: "Скопировано",
        your_courier: "Ваш курьер",
        eta_away: "8 мин ETA",
        shipping_address: "Адрес доставки",
        delivering_to: "Доставляется",
        apt_info: "Кв. 7, Этаж 3",
        recipient: "Получатель",
        est_delivery: "Ожидаемое время доставки",
        on_time: "В срок",
        arrives_today: "Прибывает сегодня",
        time_window: "± 10 мин окно",
        date_label: "Дата",
        day_saturday: "Суббота",
        section_history: "История отслеживания",
        status_updates: "Обновления статуса",
        tl_confirmed: "Заказ подтверждён",
        tl_confirmed_desc: "Посылка зарегистрирована в системе Smart Cargo",
        tl_warehouse: "Прибыла на склад",
        tl_warehouse_desc: "Посылка отсортирована и готова · Binəqədi Hub",
        tl_assigned: "Назначен курьер",
        tl_assigned_desc: "Анар Həsənов забрал вашу посылку",
        tl_enroute: "В пути 🏍️",
        tl_enroute_desc: "Курьер едет — 2.4 км от вашего адреса",
        tl_delivered: "Доставлено",
        tl_delivered_desc: "Ожидаемое время: сегодня в 14:35",
        today: "Сегодня",
        now_live: "Сейчас · Прямой эфир",
        pending: "Ожидается",
        section_prefs: "Настройки",
        delivery_instructions: "Инструкции по доставке",
        chip_door: "Оставить у двери",
        chip_ring: "Позвонить в дверь",
        chip_call: "Позвонить по приезду",
        chip_neighbour: "Оставить соседу",
        chip_nocontact: "Бесконтактная доставка",
        instr_placeholder: "Добавьте инструкции для курьера…",
        save_instructions: "Сохранить",
        reschedule: "Перенести доставку",
        optional: "Опционально",
        current_date: "Сегодня · Суббота, 12 апреля",
        current_window: "14:00 – 16:00 · Активно",
        change: "Изменить",
        select_date: "Выберите новую дату",
        time_slots: "Выберите окно доставки",
        confirm_schedule: "Подтвердить новое время",
        report_issue: "Сообщить о проблеме",
        report_title: "Сообщить о проблеме",
        report_subtitle:
            "Опишите проблему — сообщение пойдёт прямо в команду Smart Cargo.",
        issue_late: "Задержка доставки",
        issue_wrong: "Не тот товар",
        issue_damaged: "Повреждённый товар",
        issue_courier: "Поведение курьера",
        issue_missing: "Посылка не найдена",
        issue_other: "Другое",
        issue_desc_label: "Опишите проблему",
        issue_placeholder: "Подробно опишите что произошло…",
        issue_contact_label: "Ваш телефон (для обратной связи)",
        issue_submit: "Отправить администратору",
        issue_success_title: "Жалоба отправлена!",
        issue_success_desc:
            "Ваша жалоба отправлена команде Smart Cargo. Мы разберёмся и свяжемся с вами.",
        toast_copied: "Номер скопирован!",
        toast_instructions: "Инструкции сохранены!",
        toast_noinstruction: "Пожалуйста, добавьте инструкцию",
        toast_rescheduled: "Доставка перенесена!",
        toast_issue_sent: "Жалоба отправлена администратору!",
    },
};

const LANG_OPTIONS = [
    { code: "en", label: "English", native: "English", short: "EN", flag: "🇬🇧" },
    { code: "az", label: "Azerbaijani", native: "Azərbaycan dili", short: "AZ", flag: "🇦🇿" },
    { code: "ru", label: "Russian", native: "Русский", short: "RU", flag: "🇷🇺" },
];

const NAV_ITEMS = [
    { id: "tracking-top", tip: "Top" },
    { id: "sec-tracking", tip: "Package" },
    { id: "sec-courier", tip: "Courier" },
    { id: "sec-address", tip: "Address" },
    { id: "sec-eta", tip: "ETA" },
    { id: "sec-history", tip: "History" },
    { id: "sec-instructions", tip: "Instructions" },
    { id: "sec-reschedule", tip: "Reschedule" },
];

const DELIVERY_CHIPS = [
    "chip_door",
    "chip_ring",
    "chip_call",
    "chip_neighbour",
    "chip_nocontact",
];

const ISSUE_TYPES = [
    { type: "late", icon: "⏰", key: "issue_late" },
    { type: "wrong", icon: "📦", key: "issue_wrong" },
    { type: "damaged", icon: "💔", key: "issue_damaged" },
    { type: "courier", icon: "🏍️", key: "issue_courier" },
    { type: "missing", icon: "🔍", key: "issue_missing" },
    { type: "other", icon: "💬", key: "issue_other" },
];

function CheckIcon({ dark = false }) {
    return (
        <svg width="11" height="11" viewBox="0 0 11 11" fill="none">
            <path
                d="M1.5 5.5l3 3 5-5"
                stroke={dark ? "#060d18" : "currentColor"}
                strokeWidth="1.6"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}

function ArrowIcon() {
    return (
        <svg width="11" height="11" viewBox="0 0 11 11" fill="none">
            <path
                d="M1.5 5.5h8M6 2l3.5 3.5L6 9"
                stroke="#00c9a7"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}

function PinIcon() {
    return (
        <svg width="10" height="10" viewBox="0 0 10 10" fill="none">
            <path
                d="M5 1C3.07 1 1.5 2.57 1.5 4.5c0 2.75 3.5 4.5 3.5 4.5s3.5-1.75 3.5-4.5C8.5 2.57 6.93 1 5 1z"
                stroke="currentColor"
                strokeWidth="1.2"
            />
        </svg>
    );
}

function CopyIcon() {
    return (
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
            <rect x="4" y="4" width="7" height="7" rx="1.5" stroke="currentColor" strokeWidth="1.2" />
            <path d="M1 8V2a1 1 0 011-1h6" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" />
        </svg>
    );
}

function buildCalendarDays(today = new Date()) {
    const year = today.getFullYear();
    const month = today.getMonth();
    const firstDay = new Date(year, month, 1).getDay();
    const daysInMonth = new Date(year, month + 1, 0).getDate();

    const cells = [];

    for (let i = 0; i < firstDay; i += 1) {
        cells.push({ key: `empty-${i}`, value: "", empty: true });
    }

    for (let day = 1; day <= daysInMonth; day += 1) {
        cells.push({
            key: `day-${day}`,
            value: day,
            today: day === today.getDate(),
            past: day < today.getDate(),
        });
    }

    return cells;
}

function buildTimeOptions() {
    const options = [];
    for (let hour = 8; hour <= 22; hour += 1) {
        options.push(`${String(hour).padStart(2, "0")}:00`);
    }
    return options;
}

export default function TrackingPage() {
    const [lang, setLang] = useState("en");
    const [langOpen, setLangOpen] = useState(false);
    const [toast, setToast] = useState(null);
    const [copied, setCopied] = useState(false);
    const [showScrollTop, setShowScrollTop] = useState(false);
    const [logoFailed, setLogoFailed] = useState(false);
    const [activeSection, setActiveSection] = useState("tracking-top");

    const [instructionText, setInstructionText] = useState("");
    const [selectedChips, setSelectedChips] = useState([]);

    const [rescheduleOpen, setRescheduleOpen] = useState(false);
    const [selectedDate, setSelectedDate] = useState(null);
    const [startTime, setStartTime] = useState(null);
    const [endTime, setEndTime] = useState(null);
    const [currentSlotDate, setCurrentSlotDate] = useState(null);
    const [currentSlotTime, setCurrentSlotTime] = useState(null);

    const [reportOpen, setReportOpen] = useState(false);
    const [reportSuccess, setReportSuccess] = useState(false);
    const [selectedIssue, setSelectedIssue] = useState(null);
    const [issueText, setIssueText] = useState("");
    const [issuePhone, setIssuePhone] = useState("");
    const [issueError, setIssueError] = useState(false);

    const t = (key) => T[lang][key] || key;
    const langMeta = LANG_OPTIONS.find((item) => item.code === lang) || LANG_OPTIONS[0];
    const calendarDays = useMemo(() => buildCalendarDays(), []);
    const timeOptions = useMemo(() => buildTimeOptions(), []);

    const slotDateText = currentSlotDate || t("current_date");
    const slotTimeText = currentSlotTime || t("current_window");
    const canConfirmSchedule = Boolean(selectedDate && startTime && endTime);
    const [packageData, setPackageData] = useState(null);
    const API_BASE = process.env.REACT_APP_API_URL || "https://smart-cargo-backend-923182991420.us-central1.run.app";

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const id = params.get("id");
        const code = params.get("code");
        if (id) {
            fetch(`${API_BASE}/api/packages/${id}`)
                .then(r => r.json()).then(setPackageData).catch(() => {});
        } else if (code) {
            fetch(`${API_BASE}/api/packages?tracking_code=${encodeURIComponent(code)}`)
                .then(r => r.json())
                .then(d => Array.isArray(d) && d.length > 0 && setPackageData(d[0]))
                .catch(() => {});
        }
    }, [API_BASE]);


    useEffect(() => {
        const onScroll = () => {
            setShowScrollTop(window.scrollY > 350);

            let current = "tracking-top";
            for (const item of NAV_ITEMS) {
                const el = document.getElementById(item.id);
                if (!el) continue;
                const rect = el.getBoundingClientRect();
                if (rect.top <= 120) current = item.id;
            }
            setActiveSection(current);
        };

        onScroll();
        window.addEventListener("scroll", onScroll, { passive: true });

        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    useEffect(() => {
        document.body.style.overflow = reportOpen || langOpen ? "hidden" : "";
        return () => {
            document.body.style.overflow = "";
        };
    }, [reportOpen, langOpen]);

    function showToastMessage(message, icon = "✅") {
        setToast({ message, icon });
        window.clearTimeout(showToastMessage.timer);
        showToastMessage.timer = window.setTimeout(() => setToast(null), 2600);
    }

    async function copyTracking() {
        try {
            await navigator.clipboard.writeText(TRACKING_NUMBER);
        } catch {
            const input = document.createElement("input");
            input.value = TRACKING_NUMBER;
            document.body.appendChild(input);
            input.select();
            document.execCommand("copy");
            input.remove();
        }

        setCopied(true);
        showToastMessage(t("toast_copied"), "📋");
        window.setTimeout(() => setCopied(false), 1600);
    }

    function changeLanguage(nextLang) {
        setLang(nextLang);
        setLangOpen(false);
        const label = {
            en: "Language: English",
            az: "Dil: Azərbaycanca",
            ru: "Язык: Русский",
        }[nextLang];
        showToastMessage(label, "🌐");
    }

    function scrollToSection(id) {
        const el = document.getElementById(id);
        if (!el) return;
        el.scrollIntoView({ behavior: "smooth", block: "start" });
    }

    function toggleChip(chipKey) {
        const chipText = t(chipKey);

        setSelectedChips((prev) =>
            prev.includes(chipKey)
                ? prev.filter((key) => key !== chipKey)
                : [...prev, chipKey]
        );

        setInstructionText((prev) => {
            if (prev.includes(chipText)) return prev;
            return prev ? `${prev}; ${chipText}` : chipText;
        });
    }

    function saveInstructions() {
        if (!instructionText.trim()) {
            showToastMessage(t("toast_noinstruction"), "⚠️");
            return;
        }

        showToastMessage(t("toast_instructions"), "✅");
    }

    function selectStartTime(time) {
        setStartTime(time);

        if (endTime && time >= endTime) {
            setEndTime(null);
        }
    }

    function confirmReschedule() {
        if (!canConfirmSchedule) return;

        const month = new Date().toLocaleString("en-US", { month: "short" });
        setCurrentSlotDate(`${month} ${selectedDate}`);
        setCurrentSlotTime(`${startTime} – ${endTime} · Confirmed`);
        setRescheduleOpen(false);
        setSelectedDate(null);
        setStartTime(null);
        setEndTime(null);
        showToastMessage(t("toast_rescheduled"), "📅");
    }

    function closeReport() {
        setReportOpen(false);
        window.setTimeout(() => {
            setReportSuccess(false);
            setSelectedIssue(null);
            setIssueText("");
            setIssuePhone("");
            setIssueError(false);
        }, 250);
    }

    function submitIssue() {
        if (!issueText.trim()) {
            setIssueError(true);
            window.setTimeout(() => setIssueError(false), 2000);
            return;
        }

        const subject = `Customer Issue - ${TRACKING_NUMBER}${selectedIssue ? ` [${selectedIssue}]` : ""}`;
        const body =
            `Tracking: ${TRACKING_NUMBER}\n` +
            `Issue: ${selectedIssue || "Not specified"}\n` +
            `Description: ${issueText.trim()}\n` +
            `Phone: ${issuePhone.trim() || "Not provided"}\n` +
            `Time: ${new Date().toLocaleString()}`;

        window.open(
            `mailto:smartcargo.baku@gmail.com?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`
        );

        setReportSuccess(true);
        showToastMessage(t("toast_issue_sent"), "📨");
        window.setTimeout(closeReport, 4000);
    }

    return (
        <div className="tracking-page" id="tracking-top">
            <div className={`toast ${toast ? "show" : ""}`}>
                <span>{toast?.icon || "✅"}</span>
                <span>{toast?.message}</span>
            </div>

            <button
                className={`scroll-top-btn ${showScrollTop ? "show" : ""}`}
                type="button"
                onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
                aria-label="Scroll to top"
            >
                <svg viewBox="0 0 16 16" fill="none">
                    <path
                        d="M8 13V3M3 8l5-5 5 5"
                        stroke="white"
                        strokeWidth="1.8"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            </button>

            <div className="side-nav">
                {NAV_ITEMS.map((item) => (
                    <button
                        key={item.id}
                        className={`snd ${activeSection === item.id ? "active" : ""}`}
                        type="button"
                        onClick={() => scrollToSection(item.id)}
                        aria-label={item.tip}
                    >
                        <span className="snd-tip">{item.tip}</span>
                    </button>
                ))}
            </div>

            <div
                className={`lang-sidebar-overlay ${langOpen ? "open" : ""}`}
                onClick={() => setLangOpen(false)}
            />

            <aside className={`lang-sidebar ${langOpen ? "open" : ""}`}>
                <div className="lsb-header">
                    <div className="lsb-title">{t("lang_select")}</div>
                    <button className="lsb-close" type="button" onClick={() => setLangOpen(false)}>
                        ×
                    </button>
                </div>
                <div className="lsb-subtitle">{t("lang_available")}</div>

                {LANG_OPTIONS.map((item) => (
                    <button
                        key={item.code}
                        type="button"
                        className={`lang-option ${lang === item.code ? "active" : ""}`}
                        onClick={() => changeLanguage(item.code)}
                    >
                        <div className="lang-flag">{item.flag}</div>
                        <div className="lang-info">
                            <div className="lang-name">{item.label}</div>
                            <div className="lang-native">{item.native}</div>
                        </div>
                        <div className="lang-check">
                            <svg viewBox="0 0 10 10" fill="none">
                                <path
                                    d="M1.5 5l2.5 2.5 4.5-4.5"
                                    stroke="white"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                        </div>
                    </button>
                ))}
            </aside>

            <div className={`modal-overlay ${reportOpen ? "open" : ""}`} onClick={closeReport}>
                <div className="modal-sheet" onClick={(event) => event.stopPropagation()}>
                    <div className="modal-handle" />
                    <div className="modal-header">
                        <div className="modal-title">{t("report_title")}</div>
                        <button className="modal-close" type="button" onClick={closeReport}>
                            ×
                        </button>
                    </div>

                    <div className="modal-body">
                        {!reportSuccess ? (
                            <>
                                <div className="report-subtitle">{t("report_subtitle")}</div>

                                <div className="issue-types">
                                    {ISSUE_TYPES.map((item) => (
                                        <button
                                            key={item.type}
                                            type="button"
                                            className={`issue-type ${selectedIssue === item.type ? "sel" : ""}`}
                                            onClick={() => setSelectedIssue(item.type)}
                                        >
                                            <span className="it-icon">{item.icon}</span>
                                            <span className="it-label">{t(item.key)}</span>
                                        </button>
                                    ))}
                                </div>

                                <div className="fg">
                                    <label>{t("issue_desc_label")}</label>
                                    <textarea
                                        value={issueText}
                                        onChange={(event) => setIssueText(event.target.value)}
                                        placeholder={t("issue_placeholder")}
                                        className={issueError ? "field-error" : ""}
                                    />
                                </div>

                                <div className="fg">
                                    <label>{t("issue_contact_label")}</label>
                                    <textarea
                                        className="phone-textarea"
                                        value={issuePhone}
                                        onChange={(event) => setIssuePhone(event.target.value)}
                                        placeholder="+994 55 XXX XX XX"
                                    />
                                </div>

                                <button className="issue-submit" type="button" onClick={submitIssue}>
                                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                                        <path
                                            d="M1 7l5 5 7-7"
                                            stroke="currentColor"
                                            strokeWidth="1.8"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                    </svg>
                                    <span>{t("issue_submit")}</span>
                                </button>
                            </>
                        ) : (
                            <div className="issue-success active">
                                <div className="is-icon">📨</div>
                                <h4>{t("issue_success_title")}</h4>
                                <p>{t("issue_success_desc")}</p>
                            </div>
                        )}
                    </div>
                </div>
            </div>

            <header className="top-header fade-in">
                <div className="header-logo">
                    {!logoFailed ? (
                        <img
                            src="/imgs/logo.png"
                            alt="Smart Cargo"
                            onError={() => setLogoFailed(true)}
                        />
                    ) : (
                        <div className="logo-fallback" aria-label="Smart Cargo">
                            <span className="logo-mark">SC</span>
                            <span className="logo-text">Smart Cargo</span>
                        </div>
                    )}
                </div>

                <div className="header-right">
                    <div className="header-tracking">
                        <div className="label">{t("tracking_label")}</div>
                        <div className="num">{TRACKING_NUMBER}</div>
                    </div>

                    <button className="lang-btn" type="button" onClick={() => setLangOpen(true)}>
                        <span className="globe">🌐</span>
                        <span>{langMeta.short}</span>
                    </button>
                </div>
            </header>

            <section className="status-hero fade-in-1">
                <div className="status-eyebrow">
                    <div className="pulse" />
                    <span>{t("live_update")}</span>
                </div>
                <h1 className="status-title">{t("status_current")}</h1>

                <div className="status-steps">
                    <div className="sstep done">
                        <div className="sstep-dot"><CheckIcon dark /></div>
                        <div className="sstep-label">{t("step_ordered")}</div>
                    </div>
                    <div className="sstep done">
                        <div className="sstep-dot"><CheckIcon dark /></div>
                        <div className="sstep-label">{t("step_warehouse")}</div>
                    </div>
                    <div className="sstep done">
                        <div className="sstep-dot"><CheckIcon dark /></div>
                        <div className="sstep-label">{t("step_picked")}</div>
                    </div>
                    <div className="sstep active">
                        <div className="sstep-dot"><ArrowIcon /></div>
                        <div className="sstep-label">{t("step_enroute")}</div>
                    </div>
                    <div className="sstep">
                        <div className="sstep-dot"><PinIcon /></div>
                        <div className="sstep-label">{t("step_delivered")}</div>
                    </div>
                </div>
            </section>

            <main className="main">
                <div className="sec-lbl fade-in-2">{t("section_package")}</div>

                <section className="card fade-in-2" id="sec-tracking">
                    <div className="card-header">
                        <div className="card-title">
                            <div className="card-icon">🔢</div>
                            <span>{t("tracking_number")}</span>
                        </div>
                        <span className="card-badge badge-active">{t("badge_active")}</span>
                    </div>

                    <div className="track-num-wrap">
                        <div>
                            <div className="track-num">{TRACKING_NUMBER}</div>
                            <div className="track-num-sub">{t("track_sub")}</div>
                        </div>

                        <button
                            className={`copy-btn ${copied ? "copied" : ""}`}
                            type="button"
                            onClick={copyTracking}
                        >
                            <CopyIcon />
                            <span>{copied ? `✓ ${t("copy")}` : t("copy")}</span>
                        </button>
                    </div>
                </section>

                <section className="card fade-in-2" id="sec-courier">
                    <div className="card-header">
                        <div className="card-title">
                            <div className="card-icon">🏍️</div>
                            <span>{t("your_courier")}</span>
                        </div>
                        <div className="courier-rating">⭐ 4.9</div>
                    </div>

                    <div className="courier-wrap">
                        <div className="courier-avatar">AH</div>
                        <div className="courier-info">
                            <div className="courier-name">Anar Həsənov</div>
                            <div className="courier-meta">
                                <span>·</span>
                                <span className="teal-text">{t("eta_away")}</span>
                            </div>
                        </div>
                        <div className="courier-actions">
                            <a href="tel:+994501234567" className="courier-btn" title="Call courier">
                                📞
                            </a>
                        </div>
                    </div>
                </section>

                <section className="card fade-in-3" id="sec-address">
                    <div className="card-header">
                        <div className="card-title">
                            <div className="card-icon">📍</div>
                            <span>{t("shipping_address")}</span>
                        </div>
                    </div>

                    <div className="addr-grid">
                        <div className="addr-item">
                            <div className="addr-label">{t("delivering_to")}</div>
                            <div className="addr-val">Nizami St, 42</div>
                            <div className="addr-sub">{t("apt_info")}</div>
                            <div className="addr-sub">Nasimi, Baku</div>
                        </div>

                        <div className="addr-item">
                            <div className="addr-label">{t("recipient")}</div>
                            <div className="addr-val">Aytən Rəsulova</div>
                            <div className="addr-sub">+994 55 269-37-39</div>
                        </div>
                    </div>
                </section>

                <section className="card fade-in-3" id="sec-eta">
                    <div className="card-header">
                        <div className="card-title">
                            <div className="card-icon">🕐</div>
                            <span>{t("est_delivery")}</span>
                        </div>
                        <span className="card-badge badge-active">{t("on_time")}</span>
                    </div>

                    <div className="eta-wrap">
                        <div className="eta-box">
                            <div className="eta-lbl">{t("arrives_today")}</div>
                            <div className="eta-val">14:35</div>
                            <div className="eta-sub">{t("time_window")}</div>
                        </div>
                        <div className="eta-box">
                            <div className="eta-lbl">{t("date_label")}</div>
                            <div className="eta-val eta-date">Apr 12, 2026</div>
                            <div className="eta-sub">{t("day_saturday")}</div>
                        </div>
                    </div>
                </section>

                <div className="sec-lbl fade-in-4" id="sec-history">
                    {t("section_history")}
                </div>

                <section className="card fade-in-4">
                    <div className="card-header">
                        <div className="card-title">
                            <div className="card-icon">📋</div>
                            <span>{t("status_updates")}</span>
                        </div>
                    </div>

                    <div className="timeline">
                        <div className="tl-item done">
                            <div className="tl-left"><div className="tl-dot done"><CheckIcon dark /></div></div>
                            <div className="tl-right">
                                <div className="tl-title">{t("tl_confirmed")}</div>
                                <div className="tl-desc">{t("tl_confirmed_desc")}</div>
                                <div className="tl-time">🕐 {t("today")}, 11:00</div>
                            </div>
                        </div>

                        <div className="tl-item done">
                            <div className="tl-left"><div className="tl-dot done"><CheckIcon dark /></div></div>
                            <div className="tl-right">
                                <div className="tl-title">{t("tl_warehouse")}</div>
                                <div className="tl-desc">{t("tl_warehouse_desc")}</div>
                                <div className="tl-time">🕐 {t("today")}, 12:15</div>
                            </div>
                        </div>

                        <div className="tl-item done">
                            <div className="tl-left"><div className="tl-dot done"><CheckIcon dark /></div></div>
                            <div className="tl-right">
                                <div className="tl-title">{t("tl_assigned")}</div>
                                <div className="tl-desc">{t("tl_assigned_desc")}</div>
                                <div className="tl-time">🕐 {t("today")}, 13:20</div>
                            </div>
                        </div>

                        <div className="tl-item active">
                            <div className="tl-left">
                                <div className="tl-dot active">
                                    <svg width="9" height="9" viewBox="0 0 9 9" fill="none">
                                        <circle cx="4.5" cy="4.5" r="2" fill="#00c9a7" />
                                    </svg>
                                </div>
                            </div>
                            <div className="tl-right">
                                <div className="tl-title active-title">{t("tl_enroute")}</div>
                                <div className="tl-desc">{t("tl_enroute_desc")}</div>
                                <div className="tl-time live-time">⚡ {t("now_live")}</div>
                            </div>
                        </div>

                        <div className="tl-item">
                            <div className="tl-left"><div className="tl-dot pending" /></div>
                            <div className="tl-right">
                                <div className="tl-title">{t("tl_delivered")}</div>
                                <div className="tl-desc">{t("tl_delivered_desc")}</div>
                                <div className="tl-time">⏳ {t("pending")}</div>
                            </div>
                        </div>
                    </div>
                </section>

                <div className="sec-lbl fade-in-5" id="sec-instructions">
                    {t("section_prefs")}
                </div>

                <section className="card fade-in-5">
                    <div className="card-header">
                        <div className="card-title">
                            <div className="card-icon">📝</div>
                            <span>{t("delivery_instructions")}</span>
                        </div>
                    </div>

                    <div className="instr-body">
                        <div className="instr-chips">
                            {DELIVERY_CHIPS.map((chipKey) => (
                                <button
                                    key={chipKey}
                                    type="button"
                                    className={`instr-chip ${selectedChips.includes(chipKey) ? "sel" : ""}`}
                                    onClick={() => toggleChip(chipKey)}
                                >
                                    {t(chipKey)}
                                </button>
                            ))}
                        </div>

                        <textarea
                            className="instr-textarea"
                            value={instructionText}
                            onChange={(event) => setInstructionText(event.target.value)}
                            placeholder={t("instr_placeholder")}
                        />

                        <button className="instr-save" type="button" onClick={saveInstructions}>
                            <CheckIcon />
                            <span>{t("save_instructions")}</span>
                        </button>
                    </div>
                </section>

                <section className="card fade-in-6" id="sec-reschedule">
                    <div className="card-header">
                        <div className="card-title">
                            <div className="card-icon">📅</div>
                            <span>{t("reschedule")}</span>
                        </div>
                        <span className="card-badge badge-warn">{t("optional")}</span>
                    </div>

                    <div className="resched-body">
                        <div className="current-slot">
                            <span className="slot-icon">📅</span>
                            <div className="slot-info">
                                <div className="slot-date">{slotDateText}</div>
                                <div className="slot-time">{slotTimeText}</div>
                            </div>
                            <button
                                className="change-link"
                                type="button"
                                onClick={() => setRescheduleOpen((value) => !value)}
                            >
                                {t("change")}
                            </button>
                        </div>

                        {rescheduleOpen && (
                            <div className="reschedule-panel">
                                <div className="resched-mini">
                                    <div className="resched-mini-header">
                                        <span className="resched-mini-title">{t("select_date")}</span>
                                        <button
                                            type="button"
                                            className="mini-close"
                                            onClick={() => setRescheduleOpen(false)}
                                        >
                                            ×
                                        </button>
                                    </div>

                                    <div className="cal-compact">
                                        {["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"].map((day) => (
                                            <div className="cal-day-lbl" key={day}>{day}</div>
                                        ))}

                                        {calendarDays.map((day) => (
                                            <button
                                                key={day.key}
                                                type="button"
                                                className={[
                                                    "cal-cell",
                                                    day.empty ? "empty" : "",
                                                    day.today ? "today" : "",
                                                    day.past ? "past" : "",
                                                    selectedDate === day.value ? "selected" : "",
                                                ].join(" ")}
                                                disabled={day.empty || day.past}
                                                onClick={() => setSelectedDate(day.value)}
                                            >
                                                {day.value}
                                            </button>
                                        ))}
                                    </div>
                                </div>

                                <div className="panel-space" />

                                <div className="resched-mini">
                                    <div className="resched-mini-header">
                                        <span className="resched-mini-title">{t("time_slots")}</span>
                                    </div>

                                    <div className="time-range-wrap">
                                        <div className="time-range-label">From → To</div>
                                        <div className="time-range-row">
                                            <div className="time-scroll-col">
                                                <div className="time-scroll-label">Start</div>
                                                <div className="time-scroll">
                                                    {timeOptions.slice(0, -1).map((time) => (
                                                        <button
                                                            type="button"
                                                            key={time}
                                                            className={`time-option ${startTime === time ? "selected" : ""}`}
                                                            onClick={() => selectStartTime(time)}
                                                        >
                                                            {time}
                                                        </button>
                                                    ))}
                                                </div>
                                            </div>

                                            <div className="time-range-arrow">→</div>

                                            <div className="time-scroll-col">
                                                <div className="time-scroll-label">End</div>
                                                <div className="time-scroll">
                                                    {timeOptions.slice(1).map((time) => {
                                                        const disabled = startTime ? time <= startTime : false;
                                                        return (
                                                            <button
                                                                type="button"
                                                                key={time}
                                                                disabled={disabled}
                                                                className={`time-option ${endTime === time ? "selected" : ""} ${
                                                                    disabled ? "disabled" : ""
                                                                }`}
                                                                onClick={() => setEndTime(time)}
                                                            >
                                                                {time}
                                                            </button>
                                                        );
                                                    })}
                                                </div>
                                            </div>
                                        </div>

                                        {startTime && endTime && (
                                            <div className="time-summary show">
                                                Window: <strong>{startTime} – {endTime}</strong>
                                            </div>
                                        )}
                                    </div>
                                </div>

                                <div className="panel-space" />

                                <button
                                    className="resched-confirm"
                                    type="button"
                                    disabled={!canConfirmSchedule}
                                    onClick={confirmReschedule}
                                >
                                    <CheckIcon />
                                    <span>{t("confirm_schedule")}</span>
                                </button>
                            </div>
                        )}
                    </div>
                </section>
                {/* Show rating widget only for delivered packages */}
                {packageData?.status === "Delivered" && (
                    <>
                        <div className="sec-lbl fade-in-4">
                            {lang === "az" ? "Qiymətləndirmə"
                                : lang === "ru" ? "Оценка"
                                    : "Rate Your Delivery"}
                        </div>
                        <DeliveryFeedback
                            packageId={packageData.id}
                            trackingCode={String(packageData.tracking_code)}
                            lang={lang}
                        />
                    </>
                )}

                <div className="page-bottom-space" />
            </main>

            <div className="bottom-bar">
                <button className="report-btn" type="button" onClick={() => setReportOpen(true)}>
                    🚨 <span>{t("report_issue")}</span>
                </button>
            </div>
        </div>
    );
}
